<template>
  <ipo3-page>
    <template slot="title">標籤清單</template>
    <template slot="tools">
      <el-input v-model="form.title" style="width:200px;margin-right:10px;" placeholder="請輸入標題"></el-input>
      <el-select v-model="form.language" placeholder="請選擇語言" style="margin-right:10px;">
              <el-option
                v-for="item in languages"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
      </el-select>
      <el-button icon="el-icon-edit" @click="onSearch" type="primary">搜索</el-button>
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">添加標籤</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row)"
                  size="mini"
                  type="success"
                >{{$t('btns.edit')}}</el-button>
                                <el-button
                  @click="onDelete(scope.$index, scope.row.id, 0)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <tags-dialog ref="tagsDialog" @sucess="onSucess"></tags-dialog>
    </template>
  </ipo3-page>
</template>
<script>
import tagsDialog from './views/tags_dialog'
export default {
  name: "news-theme",
  components:{tagsDialog},
  data() {
    return {
      tableData: [],
      languages: [{id: '', name: '全部'}, {id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" },
        { name: "語言", id: "language_text" },
        { name: "排序", id: "sort" },
        { name: "狀態", id: "status_text" },
        { name: "時間", id: "create_time" }
      ],
      form:{
        language: '',
        title:''
      },
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onHandle(index,value)
    {
      this.$refs.tagsDialog.show(value, value.language, false);
    },
    onSucess()
    {
      this.getData();
    },
    onCreate(){
      this.$refs.tagsDialog.show(null, 'tw', false);
    },
    onDelete(index, id) {
      var self = this;
      this.$http.get("/admin/tags/delete", { id: id }).then(res => {
        if (res.code == 200) {
          self.getData();
        }
      });
    },
     onSearch()
    {
      let params = Object.assign({},this.form);
      
      this.getData(this.currentPage,this.paginate,params);
    },
    getData(page = 1, size = 10,value={}) {
      var self = this;
      this.$http.get("/admin/tags", { page: page, size: size,...value }).then(res => {
        console.log("res:", res);
        let { total } = res.data;
        self.pagecount = total;
        self.tableData = res.data.data;
      });
    },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getData(this.currentPage, this.paginate);
    },
    handleSizeChange(size) {
      this.paginate = size;
      this.getData(this.currentPage, this.paginate);
    },
  }
};
</script>